module.exports = __webpack_public_path__ + "static/img/3_9_1.869c1a15.jpg";